import { render } from "./Loader.vue?vue&type=template&id=a4cc1956&scoped=true"
import script from "./Loader.vue?vue&type=script&lang=js"
export * from "./Loader.vue?vue&type=script&lang=js"

import "./Loader.vue?vue&type=style&index=0&id=a4cc1956&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a4cc1956"

export default script